import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { consumeAdminMagicLink } from '../services/adminMagicLinkApi';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import '../../admin-auth/styles/adminLoginPage.css';

export default function AdminMagicLinkPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setError('Invalid or missing login link token.');
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError('');
        await consumeAdminMagicLink({ token });
        try {
          localStorage.setItem('admin_2fa_verified_at', String(Date.now()));
        } catch {
          // ignore
        }
        setSuccess(true);

        // Best-effort: close this tab/window if it was opened from the login page.
        setTimeout(() => {
          try {
            if (window.opener) {
              window.close();
            }
          } catch {
            // ignore
          }
        }, 900);
      } catch (e) {
        setError(e?.message || 'This login link is invalid or expired.');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [token, navigate]);

  return (
    <div className="adminLogin">
      <div className="adminLogin__bg" aria-hidden="true" />
      <main className="adminLogin__container">
        <section className="adminLogin__card" aria-label="Admin magic link sign in">
          <header className="adminLogin__header">
            <div className="adminLogin__badge" aria-hidden="true">
              Admin
            </div>
            <h1 className="adminLogin__title">
              {loading ? 'Signing you in…' : success ? 'Success' : 'Admin sign-in link'}
            </h1>
            <p className="adminLogin__subtitle">
              {loading
                ? 'Please wait while we verify your login link.'
                : error
                  ? 'We couldn’t verify this link.'
                  : success
                    ? 'You can close this tab now. Your original login page should sign you in automatically.'
                    : 'You can close this tab.'}
            </p>
          </header>

          {error ? (
            <div className="adminLogin__alert" role="alert">
              <span className="adminLogin__alertDot" aria-hidden="true" />
              <span>{error}</span>
            </div>
          ) : null}

          <div className="adminLogin__divider" aria-hidden="true" />

          {!success ? (
            <div className="adminLogin__form">
              <button
                className="adminLogin__submit"
                type="button"
                onClick={() => navigate(adminPath(ADMIN_PATHS.LOGIN), { replace: true })}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="adminLogin__spinner" aria-hidden="true" />
                    Signing in…
                  </>
                ) : (
                  'Back to login'
                )}
              </button>
            </div>
          ) : null}
        </section>
      </main>
    </div>
  );
}

